import Dispatcher from '../dispatcher'

export default {

  redeemAccessCode(vbid) {

    Jigsaw.redeemAncillary(vbid, (response) => {
      Dispatcher.emit(Dispatcher.ACCESS_CODE_STORE_CHANGE);
    })

  }


}



/** WEBPACK FOOTER **
 ** ./src/js/actions/resource-action.js
 **/